<template lang="html">
    <div class="create-dynamic" :style="{ height: isAndroid ? 'calc(100vh - 50px)' : `calc(100vh - ${ 50 + safeHeight }px)` }">
        <!-- <h3>发动态</h3> -->
        <div class="menus">
            <button class="cancel" @click="cancel" >取消</button>
            <button class="primary" :disabled="disabled" @click="submit">发表</button>
        </div>
        <textarea ref="textarea" class="content" v-model="content" autofocus :placeholder="placeholder"></textarea>
        <div class="img-box" v-if="!getCircleId">
          <img v-if="loading" class="loading" src="../../assets/images/loading.svg"/>
          <div v-for="(item, index) of imgs" :class="{ img: true,  square: Object.is(imgs.length, 4)}"  :key="item.sort">
            <img v-lazy="`${item.url}?x-oss-process=image/resize,fill,w_196,h_196`" />
            <img @click="removeImg(index)" src="../../assets/images/removeImg.svg" class="remove-img"/>
          </div>
            <div v-if="imgs.length < 9" class="img last">
                <span class="img-row"/>
                <span class="img-column"/>
                <input class="uploadFile" @change="uploadFile" type="file"/>
            </div>
        </div>
        <div class="tags" v-if="!getCircleId && tags.length">
          <h4>点亮下方标签以加入话题/活动</h4>
          <div class="tag-box">
            <span v-for="tag of tags" @click="checkedTag(`${tag.id}`)" :class="{ active: `${tag.id}` === tagId }" :key="tag.id"># {{tag.title}}</span>
          </div>
        </div>
        <Message v-if="showMessage" @closeModel="closeModel" :label="messageLabel"/>
    </div>
</template>
<script>
import { get, post, putFile } from '../../utils/request.js'
import { get as getUser } from '../../utils/token'
import { isAndroid } from '../../utils/utils'
import { CAMPHOST } from '../../utils/config'
import Message from '../../components/message'
import dd from 'DD'
export default {
  components: {
    Message
  },
  data () {
    return {
      content: '',
      imgs: [],
      isAndroid: isAndroid(),
      safeHeight: 0,
      placeholder: '这一刻的想法…',
      showMessage: false,
      messageLabel: '不能为空',
      tags: [],
      tagId: 'all',
      loading: false,
      disabled: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const query = vm.$route.query
      let title = ''
      if (query.circleId) {
        title = '写留言'
      } else {
        title = '发动态'
      }
      if (query.curriculumId && !query.circleId) {
        title = '请留言'
      }
      if (dd.env.platform !== 'notInDingTalk') {
        dd.ready(function () {
          dd.biz.navigation.setTitle({
            title: title
          })
        })
      }
      document.title = title
    })
  },
  mounted () {
    const query = this.$route.query
    if (query.circleId || query.curriculumId) {
      this.placeholder = '回复'
    }
    if (!query.curriculumId && !query.circleId) {
      this.getTags()
    }
    if (query.curriculumId && !query.circleId) {
      this.placeholder = '请写下你的看法'
    }
    if (query.parentNickName) {
      this.placeholder = `回复${query.parentNickName}：`
    }
    if (query.parentNickName) {
      this.placeholder = `回复${query.parentNickName}：`
    }
    this.$nextTick(() => {
      const text = this.$refs.textarea
      text.focus()
      this.autoTextarea(text)
    })
  },
  methods: {
    removeImg (index) {
      this.imgs.splice(index, 1)
    },
    getTags () {
      const promise = get({
        url: '/circle/tag',
        baseURL: CAMPHOST
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          this.tags = detail
        }
      })
    },
    checkedTag (tagId) {
      this.tagId = tagId
    },
    autoTextarea (elem, extra, maxHeight) {
      extra = extra || 0
      const isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window
      const isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera')
      const addEvent = function (type, callback) {
        elem.addEventListener
          ? elem.addEventListener(type, callback, false)
          : elem.attachEvent('on' + type, callback)
      }
      const getStyle = elem.currentStyle ? function (name) {
        const val = elem.currentStyle[name]

        if (name === 'height' && val.search(/px/i) !== 1) {
          const rect = elem.getBoundingClientRect()
          return rect.bottom - rect.top -
                                        parseFloat(getStyle('paddingTop')) -
                                        parseFloat(getStyle('paddingBottom')) + 'px'
        };

        return val
      } : function (name) {
        return getComputedStyle(elem, null)[name]
      }
      const minHeight = parseFloat(getStyle('height'))

      elem.style.resize = 'none'

      const change = function () {
        let scrollTop; let height
        let padding = 0
        const style = elem.style

        if (elem._length === elem.value.length) return
        elem._length = elem.value.length

        if (!isFirefox && !isOpera) {
          padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'))
        };
        scrollTop = document.body.scrollTop || document.documentElement.scrollTop

        elem.style.height = minHeight + 'px'
        if (elem.scrollHeight > minHeight) {
          if (maxHeight && elem.scrollHeight > maxHeight) {
            height = maxHeight - padding
            style.overflowY = 'auto'
          } else {
            height = elem.scrollHeight - padding
            style.overflowY = 'hidden'
          };
          style.height = height + extra + 'px'
          scrollTop += parseInt(style.height) - elem.currHeight
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop
          elem.currHeight = parseInt(style.height)
        };
      }

      addEvent('propertychange', change)
      addEvent('input', change)
      addEvent('focus', change)
      change()
    },
    cancel () {
      this.$router.back()
    },
    closeModel () {
      this.showMessage = false
      this.messageLabel = ''
    },
    checkoutSensitiveWords () {
      const { content } = this
      const words = [/郭广昌/, /汪群斌/, /陈启宇/, /徐晓亮/]
      let label = null
      try {
        words.forEach(item => {
          label = item.exec(content)
          if (label) {
            throw new Error(label)
          }
        })
      } catch (e) {
        /* eslint-disable-next-line */
        console.log('e', e)
      }
      return label
    },
    submit () {
      // const label = this.checkoutSensitiveWords()
      // if (label) {
      //   this.showMessage = true
      //   this.messageLabel = `不许出现${label}字段`
      //   return
      // }
      const query = this.$route.query
      if (query.parentNickName) {
        delete query.parentNickName
      }
      const { content } = this
      if (!content.length) {
        this.showMessage = true
        return
      }
      if (query.curriculumId && !query.circleId) { // 专辑一级评论
        this.submitCurriculumMessage()
      } else {
        if (query.circleId) {
          this.submitComment()
        } else {
          this.submitCircle()
        }
      }
    },
    submitCurriculumMessage () {
      const { content } = this
      const query = this.$route.query
      const data = {
        content: content.replace(/\n/g, '<br/>'),
        userId: getUser('user').id,
        curriculumId: query.curriculumId
      }
      if (query.imgUrl) {
        data.imgUrl = query.imgUrl
      }
      const promise = post({
        url: '/course/comment',
        data,
        baseURL: CAMPHOST
      })
      promise.then(res => {
        this.disabled = false
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.$router.back()
        }
      }).catch(err => {
        /* eslint-disable-next-line */
        console.log('err', err)
        this.disabled = false
      })
    },
    submitCircle () {
      this.disabled = true
      const { content, imgs, tags } = this
      const _tags = tags.filter(item => `${item.id}` === this.tagId).map(item => item.id)
      const data = {
        content: content.replace(/\n/g, '<br/>'),
        images: imgs,
        tags: _tags,
        userId: getUser('user').id
      }
      const promise = post({
        url: '/circle/circle',
        data,
        baseURL: CAMPHOST
      })
      promise.then(res => {
        const { data: { code } } = res
        this.disabled = false
        if (Object.is(code, 200)) {
          // this.$router.push('/dynamic')
          this.$router.push({
            name: '/dynamic',
            query: {
              isSucceed: true
            }
          })
        }
      }).catch(err => {
        /* eslint-disable-next-line */
        console.log('err', err)
        this.disabled = false
      })
    },
    submitComment () {
      this.disabled = true
      const { content } = this
      const query = this.$route.query
      const promise = post({
        url: '/circle/comment',
        data: {
          content: content.replace(/\n/g, '<br/>'),
          userId: getUser('user').id,
          ...query
        },
        baseURL: CAMPHOST
      })
      promise.then(res => {
        this.disabled = false
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.$router.back()
        }
      }).catch(err => {
        /* eslint-disable-next-line */
        console.log('err', err)
        this.disabled = false
      })
    },
    uploadFile (e) {
      this.loading = true
      const { imgs } = this
      const img = {
        sort: imgs.length + 1,
        url: ''
      }
      imgs.push(img)
      const promise = putFile({
        url: '/bbs/uploadFile',
        file: e.target.files[0]
      })
      promise.then(res => {
        const { status, data: { data } } = res
        if (Object.is(status, 200)) {
          let url = data[0]
          if (url.indexOf('https') === -1) {
            url = url.replace('http', 'https')
          }
          img.url = url
        }
        if (Object.is(status, 205)) {
          this.messageLabel = '图片违规！'
          this.showMessage = true
          imgs.pop()
        }
        this.loading = false
      })
    }
  },
  computed: {
    getCircleId () {
      return this.$route.query.circleId || this.$route.query.curriculumId
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes roate{
  from {
     transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.create-dynamic {
    height: 100vh;
    background: #fff;
    h3 {
        font-size:17px;
        font-family:SFProText-Semibold,SFProText;
        font-weight:600;
        color:rgba(0,0,0,1);
        line-height:22px;
        text-align: center;
        padding: 13px 4.27vw;
    }
    .menus {
        box-sizing: border-box;
        padding: 8px 0;
        display: flex;
        justify-content: space-between;
        position: fixed;
        top: 0;
        left: 2.27vw;
        width: 95.46vw;
        background: #fff;
        button {
            font-size:17px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(0,0,0,1);
            line-height:24px;
            border-radius:4px;
            width: 56px;
            height: 32px;
            box-sizing: border-box;
            text-align: center;
            display: inline-block;
            background: #fff;
            border: none;
            &[disabled=disabled] {
              opacity: 0.5;
            }
        }
        .primary {
            color: #fff;
            background: #18CC9F;
        }
    }
    .content {
        -webkit-tap-highlight-color: rgba(255,0,0,0);
        box-sizing: border-box;
        width: 100%;
        padding: 0 8.52vw;
        border: none;
        outline: none;
        margin-bottom: 16px;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        line-height:24px;
        min-height: 72px;
        margin-top: 72px;
        max-height: 200px !important;
        overflow: scroll !important;;
        &::-webkit-input-placeholder {
          color:rgba(204,204,204,1);
        }
    }
    .img-box {
        padding-left: 8.52vw;
        .img {
            display: inline-block;
            width: 26.13vw;
            height: 26.13vw;
            margin-right: 1.33vw;
            background: #F5F5F5;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .remove-img {
              position: absolute;
              right: 0;
              top: 0;
              width: 32px;
              height: 32px;
            }
            .img-row, .img-column {
                background:rgba(172,172,172,1);
                position: absolute;
            }
            .img-row{
                width: 32px;
                height:2px;
                 top: calc(50% - 1px);
                left: calc(50% - 16px);
            }
            .img-column {
                height:32px;
                width: 2px;
                 top: calc(50% - 16px);
                left: calc(50% - 1px);
            }
            .uploadFile {
                position: absolute;
                top: 0;
                height: 0;
                width: 26.13vw;
                height: 26.13vw;
                outline: none;
                opacity: 0;
            }
        }
        .loading {
          width: 40px !important;
          height: 40px !important;
          z-index: 99;
          position: absolute;
          top: calc(50% - 20px);
          left: calc(50% - 20px);
          animation: roate 0.5s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
        }
        .square:nth-child(2n){
          margin-right: 30%;
        }
        .square:nth-child(2n + 1){
          margin-right: 1.33vw !important;
        }
        .last {
            position: relative;
        }
        .img:nth-child(3n) {
            margin-right: 0;
        }
    }
    .tags {
      margin: 27px 8.52vw;;
      h4 {
       height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(136,136,136,1);
        line-height:20px;
      }
      .tag-box {
        margin-top: 13px;
        span {
          height:24px;
          font-size:17px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(204,204,204,1);
          height:32px;
          background:rgba(245,245,245,1);
          border-radius:4px;
          margin-right: 12px;
          display: inline-block;
          padding: 4px 8px;
          box-sizing: border-box;
          margin-bottom: 6px;
        }
        .active {
          color: #18CC9F;
          background: #ECFDF9;
        }
      }
    }
}

</style>
